import * as React from "react";
import { AuthContext } from "../../store/AuthProvider";

export const usePermission = (type) => {
  const { auth } = React.useContext(AuthContext);
  return auth?.data?.permissions?.find((item) => item.name === type);
};
